export default String.raw`
@charset "UTF-8";

@import 'globals/_global-variables';
@import 'components/_offline';
`